<template>
  <Dialog :visible="visible" @update:visible="$emit('update:visible', $event)" header="Configurar Pizza" :modal="true" :style="{ width: '450px' }" class="p-fluid">
    <div v-if="pizza" class="flex flex-column gap-3">
      <h3 class="m-0 text-xl font-bold text-900">{{ pizza.nombre }}</h3>      

      <div class="field mt-2 flex align-items-center gap-3 bg-gray-50 p-3 border-round" v-if="!pizza.es_paquete && (pizza.mixto == 1 || pizza.mixto === true || pizza.mixto === '1')">
        <label class="font-bold text-900 m-0">¿Hacer Pizza Mixta?</label>
        <InputSwitch v-model="esMixta" />
      </div>

      <div v-if="esMixta" class="field bg-yellow-50 p-3 border-round">
        <label class="font-bold block mb-2 text-900">Selecciona la Segunda Mitad</label>
        <Dropdown v-model="pizzaMitad2" :options="pizzasParaSegundaMitad" dataKey="id" optionLabel="nombre" placeholder="Elige otra pizza" class="w-full" filter />                    
      </div>
      <div class="field mt-2 flex align-items-center gap-3 bg-gray-50 p-3 border-round">
        <label class="font-bold text-900 m-0">¿Agregar Extras?</label>
        <InputSwitch v-model="esExtra" />
      </div>

      <div v-if="esExtra" class="field bg-yellow-50 p-3 border-round">
        <CheckExtras v-model="extrasSeleccionados" titulo="Seleccione un Extra" />
      </div>
      <div class="field mt-2" v-if="false">
        <label class="font-bold block mb-3">Salsas (Máximo 4) - Elegidas: {{ totalSalsas }}/4</label>
        <div class="flex flex-column gap-3 bg-gray-50 p-3 border-round">
          <div v-for="salsa in salsasDisponibles" :key="salsa.id" class="flex align-items-center justify-content-between">
            <label class="text-900 font-medium">{{ salsa.nombre }}</label>
            <ZapiStepper 
              :cantidad="pizzaLocal['salsa_' + salsa.id] ?? 1" 
              @sumar="sumarSalsa(salsa.id)"
              @restar="pizzaLocal['salsa_' + salsa.id] = Math.max(0, (pizzaLocal['salsa_' + salsa.id] ?? 1) - 1)"
            />
          </div>
        </div>
      </div>

      <!-- SECCIÓN DE BORDES -->
      <div class="field mt-2 bg-gray-50 p-3 border-round">
        <CheckBordes v-model="bordesSeleccionados" titulo="Seleccione Bordes Extras" />
      </div>

    </div>
    <template #footer>
      <div class="flex justify-content-end gap-3 w-full border-top-1 surface-border pt-4 mt-2">
        <Button label="Cancelar" icon="pi pi-times" class="p-button-rounded border-none font-bold px-4 shadow-1" style="background-color: #9ca3af; color: white;" @click="$emit('cancelar')" :disabled="enviando" />
        <Button label="Confirmar" icon="pi pi-check" class="p-button-rounded border-none font-bold px-5 shadow-2" style="background-color: #e32f3a; color: white;" @click="confirmarSeguro" :loading="enviando" :disabled="enviando" />
      </div>
    </template>
  </Dialog>
</template>

<script>
import ZapiStepper from '@/components/shared/ZapiStepper.vue';
import CheckBordes from '@/components/shared/CheckBordes.vue';
import CheckExtras from '@/components/shared/CheckExtras.vue';
import ProductService from '@/service/ProductService';

// Variables de caché a nivel de módulo
let cachedPizzasMixtas = null;
let fetchingPizzasPromise = null;

export default {
  name: 'ZapiModalPizzaConfig',
  components: { ZapiStepper, CheckBordes, CheckExtras },
  props: {
    visible: { type: Boolean, default: false },
    pizza: { type: Object, default: null },
    salsasDisponibles: { type: Array, default: () => [] },
    catalogoPizzas: { type: Array, default: () => [] }
  },
  emits: ['update:visible', 'confirmar', 'cancelar'],
  data() {
    return {
      pizzaLocal: {},
      enviando: false,
      esMixta: false,
      pizzaMitad2: null,
      esExtra: false,
      extrasSeleccionados: [],
      pizzasMixtasDb: [],
      cargandoPizzasMixtas: false,
      bordesSeleccionados: [] // Arreglo para guardar los bordes seleccionados
    }
  },
  computed: {
    totalSalsas() {
      let total = 0;
      this.salsasDisponibles.forEach(salsa => {
        total += (this.pizzaLocal['salsa_' + salsa.id] || 0);
      });
      return total;
    },
    pizzasParaSegundaMitad() {
      if (!this.pizza) return [];
      return this.catalogoPizzas.filter(p => 
        (p.mixto === 1 || p.mixto === true || p.mixto === '1') && 
        p.id !== this.pizza.id
      );
    }
  },
  watch: {
    visible(val) {
      if (val) {
        this.enviando = false;
        // NOTA: Ya no limpiamos this.pizzasMixtasDb aquí para usar la caché
        
        if (this.pizza && this.pizza.es_mixta) {
          this.esMixta = true;
          this.pizzaMitad2 = this.pizza.pizza_mitad_2 ? { ...this.pizza.pizza_mitad_2 } : null;
        } else {
          this.esMixta = false;
          this.pizzaMitad2 = null;
        }

        if (this.pizza && this.pizza.bordes_seleccionados && this.pizza.bordes_seleccionados.length > 0) {
          this.bordesSeleccionados = [...this.pizza.bordes_seleccionados];
        } else {
          this.bordesSeleccionados = [];
        }

        if (this.pizza && this.pizza.extras_seleccionados && this.pizza.extras_seleccionados.length > 0) {
          this.esExtra = true;
          this.extrasSeleccionados = [...this.pizza.extras_seleccionados];
        } else {
          this.esExtra = false;
          this.extrasSeleccionados = [];
        }
      }
    },
    pizza: {
      immediate: true,
      handler(newPizza) {
        if (newPizza) {
          this.pizzaLocal = { ...newPizza };
        }
      }
    },
    esMixta() {
      // Ya no es necesario cargar desde el servicio, usamos catalogoPizzas
    }
  },
  methods: {
    cargarProductosDelBackend() {
      if (cachedPizzasMixtas) {
        this.pizzasMixtasDb = cachedPizzasMixtas;
        return;
      }

      if (fetchingPizzasPromise) {
        this.cargandoPizzasMixtas = true;
        fetchingPizzasPromise.then(pizzas => {
          this.pizzasMixtasDb = pizzas;
          this.cargandoPizzasMixtas = false;
        });
        return;
      }

      this.cargandoPizzasMixtas = true;
      const productService = new ProductService();
      
      fetchingPizzasPromise = productService.getAllProductos({ dt_params: JSON.stringify({ rows: 500 }) })
        .then(response => {
          if (response && response.productos && response.productos.data) {
            cachedPizzasMixtas = response.productos.data.map(p => ({
              ...p,
              nombre: p.descripcion 
            }));
            this.pizzasMixtasDb = cachedPizzasMixtas;
          }
          return cachedPizzasMixtas || [];
        })
        .catch(error => {
          console.error("Error al cargar productos desde ProductService:", error);
          fetchingPizzasPromise = null;
          return [];
        })
        .finally(() => {
          this.cargandoPizzasMixtas = false;
        });
    },
    sumarSalsa(idSalsa) {
      if (this.totalSalsas < 4) {
        this.pizzaLocal['salsa_' + idSalsa] = (this.pizzaLocal['salsa_' + idSalsa] || 0) + 1;
      } else {
        this.$toast.add({ severity: 'warn', summary: 'Límite alcanzado', detail: 'Solo puedes elegir un máximo de 4 salsas en total.', life: 3000 });
      }
    },
    confirmarSeguro() {
      if (this.enviando) return;
      if (this.esMixta && !this.pizzaMitad2) {
         this.$toast.add({ severity: 'error', summary: 'Falta Segunda Mitad', detail: 'Selecciona la otra pizza para la mitad.', life: 3000 });
         return;
      }
      this.enviando = true;
      const resultado = { ...this.pizzaLocal };
      if (this.esMixta) {
         resultado.es_mixta = true;
         resultado.pizza_mitad_2 = { ...this.pizzaMitad2 };
      } else {
         resultado.es_mixta = false;
         delete resultado.pizza_mitad_2;
      }
      // Incluimos los bordes y extras seleccionados en el resultado final
      resultado.bordes_seleccionados = [...this.bordesSeleccionados];
      resultado.extras_seleccionados = this.esExtra ? [...this.extrasSeleccionados] : [];
      this.$emit('confirmar', resultado);
    }
  }
}
</script>